import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import type { InertiaProps } from '@/types/inertia';

export const useUser = () => {
    return computed(() => (usePage<InertiaProps>().props.auth.user));
};
